var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "video-uploader" }, [_c('resumable-uploader', _vm._b({}, 'resumable-uploader', _vm.uploaderConfig, false))], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };